const ErrorThrowingComponent = () => {
	// This will throw an error during rendering
	throw new Error("This is a simulated rendering error!")
}

export default ErrorThrowingComponent
